var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClupload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.919,
    height: 46.11,
    viewBox: "0 0 52.919 46.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151267",
    "data-name": "Group 151267",
    transform: "translate(-605 -246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M278.883,132.66l.072.021,0,0a.678.678,0,0,0,.769-.475,7.247,7.247,0,0,1,6.9-5.145.678.678,0,1,0,0-1.356,8.564,8.564,0,0,0-8.205,6.114A.679.679,0,0,0,278.883,132.66Z",
    transform: "translate(353.836 124.685)",
    fill: "#146ae3",
    stroke: "#f9fff9",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M286.349,152.65h-3.378a.563.563,0,0,1,0-1.126h3.378a8.445,8.445,0,1,0,0-16.889h-.081a.562.562,0,0,1-.557-.643,7.421,7.421,0,0,0,.075-1.046,7.317,7.317,0,0,0-11.648-5.9.564.564,0,0,1-.832-.192,10.7,10.7,0,0,0-19.957,7.106.564.564,0,0,1-.552.676h-.226a8.445,8.445,0,0,0,0,16.889h3.378a.563.563,0,1,1,0,1.126H252.57a9.571,9.571,0,0,1-.442-19.131A11.825,11.825,0,0,1,274,125.783a8.445,8.445,0,0,1,12.9,7.742,9.57,9.57,0,0,1-.543,19.125Z",
    transform: "translate(362 126)",
    fill: "#146ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M258.85,157.039a14.19,14.19,0,1,0,14.189-14.189A14.206,14.206,0,0,0,258.85,157.039Zm1.357,0a12.833,12.833,0,1,1,12.832,12.833A12.847,12.847,0,0,1,260.207,157.039Z",
    transform: "translate(358.344 120.73)",
    fill: "#146ae3",
    stroke: "#f9fff9",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M276.942,165.287a.528.528,0,0,0,1.056,0V154.571a.528.528,0,0,0-1.056,0Z",
    transform: "translate(354.172 118.148)",
    fill: "#146ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M276.481,155.318l-2.924,2.924Zm0,0,2.924,2.924a.524.524,0,0,0,.372.155Zm-3.671,2.924a.527.527,0,0,0,.746,0l6.222.155a.528.528,0,0,0,.372-.9l-3.3-3.3a.527.527,0,0,0-.746,0h0l-3.3,3.3A.528.528,0,0,0,272.811,158.243Z",
    transform: "translate(355.16 118.148)",
    fill: "#146ae3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClupload);
export default __webpack_public_path__ + "static/media/clupload.63208d2be7f47f2c4676c811a68393bd.svg";
export { ForwardRef as ReactComponent };